import axios from "@/axios";
import Util from "../../../util/util";

export const namespaced = true;

export const state = {
  lssTypes: [],
};

export const getters = {
  allLssTypes: function (state) {
    return state.lssTypes;
  },
};

export const mutations = {
  SET_LSSTYPES(state, response) {
    let lssTypes = response.data;

    /*  if (!Util.isNullOrEmpty(lssTypes)) {
            lssTypes.sort(Util.sortAscByName);
        } */

    state.lssTypes = lssTypes.sort((a, b) => a.sortOrder - b.sortOrder);
  },
};

export const actions = {
  async getLssTypes({ commit }) {
    commit("SET_LSSTYPES", await axios.get("/api/lsstypes"));
  },
};
